<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <h1 class="ion-text-center">
          <ion-text color="darkmimbo">Dog Clicker</ion-text>
        </h1>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="wrapper">
          <div class="avocado">
            <div class="avocado__skin"></div>
            <button
              class="animate-button"
              color="#3e8e41"
              (click)="playAudio()"
            ></button>
            <div class="avocado__eye avocado__eye--right"></div>
          </div>
        </div>
        <div class="notification" *ngIf="isError">
          <p>
            The Dog Clicker feature is only available on mobile devices. For the
            best experience, download our app now!
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.mimbo.app"
            target="_blank"
            >Download the App</a
          >
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <div class="ion-padding">
          <ion-text color="darkmimbo">
            <h3>How To Use:</h3>
            <br />
            <div class="video-container">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/yzuYpR1109w?si=XKFaH-3uHuT4EI33"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
            <br />
            <ul>
              <li>
                To use a clicker, you’ll first need to teach the dog what the
                clicker means.
              </li>
              <li>
                To teach a dog the meaning of the click, a treat is given
                immediately after clicking.
              </li>
              <li>
                After about 10–20 repetitions, your dog will understand that the
                marker predicts a coming reward.
              </li>
              <li>
                You can test your success by clicking when your dog is not
                paying attention to you. If your dog responds to the click by
                suddenly looking at you, then looking for a treat, you are ready
                to move on.
              </li>
              <li>
                Teach your dog commands using the clicker. At the exact moment
                your dog performs the desired action, press the clicker. Follow
                with a treat and praise.
              </li>
            </ul>
          </ion-text>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
